module.exports = __webpack_public_path__ + "static/header-logo-612af6a43c79f9c7eb4f16219dd5c307.svg";